import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import doc                       from '@widesk-core/decorators/doc';
import ShowModel                 from '../fondations/ShowModel';
import model                     from '@widesk-core/decorators/model';
import TimestampAble             from '@widesk-core/models/traits/TimestampAble';
import Blamable                  from '@/models/traits/Blamable';

// Ecrit manuellement
@model.urnResource('website')
@doc.path('/websites/{?id}')
export default class WebsiteModel extends Blamable(TimestampAble(WebsiteServiceModel)) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'name': id;
		'url': id;
		'showUrn': Urn;
		'search': string;
	};

	declare private _tsSorts: {
		id: string;
		name: string;
		url: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare name: string;
	@doc.string declare url: string;
	@doc.modelUrn(ShowModel) declare show: ShowModel;

}
